import L from 'leaflet';
//import React, { useState, useRef } from 'react';

import 'leaflet-draw';
import { ROTATION_MAP_OPTIONS, setupMapRotation } from './mapRotation';
import { setupMeasureTool, isMeasureModeActive } from './measureTool';
import { highlightLine, clearLineHighlight } from './lineHighlight';

import ReactDOM from 'react-dom';

import {linkedtpArray, PPPopupSetup, AddPPSetup, EditPPSetup, ShowAllPoles, HideAllPoles, ShowPassport, SetMovingPPid, ClearPPModuleState, 
  ShowAllVisiblePoles, FillingShowingLinkedObjects, ClearShowingAllLinkedObjects, ClearShowingLinkedObjects, ShowFidersList, ShowFiderOnMap, GetActiveFiderLineId } from './PPManager';
/*import {TPPopupSetup, AddTPSetup, EditTPSetup} from './TPManager';
import {RPPopupSetup, AddRPSetup, EditRPSetup} from './RPManager';
import {RecloserPopupSetup, AddRecloserSetup, EditRecloserSetup} from './RecloserManager';*/
import { AddObjectSetup, EditObjectSetup, ObjectPopupSetup } from './objectManager';
import { OBJECT_TYPES } from './objectConfigs';
import {PolePopupSetup, AddPoleSetup, EditPoleSetup, UnLoadAllPoles} from './PoleManager';
import {AddDecorativeSetup, EditDecorativeSetup} from './SergekManager';
import {AddLine, UnLoadAllLines, deletePolylineByFromId, deletePolylineByToId, AddCurveLine, linesData } from './lines.js'
import {DrawMainMarker, DrawPoleMarker, SetDraggable, ClearMainMarkersArray, SetupZoomHandler} from './MarkerManager'

import { AddObjectSheet } from '../react-components/mobile/AddObjectSheet';
import { SupportSheet } from '../react-components/mobile/SupportSheet';

import currentLocationImage from '../images/marker-icon.png';

import ModalWrap from "./../react-components/modal/ModalWrap";
import DeleteModal from "./../react-components/modal/delete/DeleteModal";
import Statistic from "./../react-components/modal/statistic/Statistic";
import SupportModal from "./../react-components/modal/support/SupportModal";
import { SearchComponent } from "../react-components/search/SearchComponent";
import VoltageLayersControl from "../react-components/components/LinesLayers.jsx"

import { Geolocation } from '@capacitor/geolocation';

import { isMobile } from 'react-device-detect';

export var isMobileVersion = isMobile;

export var map;

var currentHighlightedMarker = null;

let pendingLineMeta = null;
let curveLineSourceMarker = null; // объект, от которого сейчас рисуется кривая линия
let drawPolyline;

export var showAllObjectsByZoom = false;

var depName = '0';

var userName = '';
var userId = null;

var userPermissions = [];

//let mapIsSet = false;

var userMarker = null; var lastInsertedId = null;
//var lastClickedMarker = null;
var currentBottomSheetContainer = null;

var lastOpenedPopup = null;

export function GetUserName() {
  return userName;
}

export function GetUserId() { 
  return userId;
}

export function GetUserPermissions() {
  return userPermissions;
}

export function SetLastOpenedPopup(popup) {
  lastOpenedPopup = popup;
}

/*export function GetLastOpenedPopup() {
  return lastOpenedPopup;
}*/

export function GetLastInsertedId() {
  return lastInsertedId;
}

export function SetLastInsertedId(id) {
  lastInsertedId = id;
}

export function MarkerClick(typecode, id, name, setOpen, setEdit) {

}

function BottomMarkerClick(linkedtp) {

}

function LogOutClick() {

}

export function OpenSideBar(isSidebar) {

}
let selectedVoltageCodes = [129,128,130,131,1];

function handleVoltageClassesChange(newCodes) {
  selectedVoltageCodes = newCodes;

  ShowAllVisiblePoles(depName, selectedVoltageCodes);
}

export function GetSelectedVoltageCodes() {
  return selectedVoltageCodes;
}

// sourceMarker — объект, от которого тянется линия: он остаётся выделенным,
// пока идёт рисование (снимается в обработчике DRAWSTOP — и при "Готово", и при "Отмена")
export function StartCurveLine(latlng, meta, sourceMarker = null) {
  pendingLineMeta = meta;
  curveLineSourceMarker = sourceMarker;
  if (sourceMarker) HighlightMarker(sourceMarker);
  drawPolyline.enable();
  drawPolyline._poly.addLatLng(latlng);
}

/*export function SetLastClickedMarker(marker) {
  lastClickedMarker = marker;
}

export function GetLastClickedMarker() {
  return lastClickedMarker;
}*/

export function CloseCurrentBottomSheet() {
  if (currentBottomSheetContainer) {
    try {
      ReactDOM.unmountComponentAtNode(currentBottomSheetContainer);
      currentBottomSheetContainer.remove();
    } catch (e) {}
    currentBottomSheetContainer = null;
  }
}

export function SetCurrentBottomSheet(container) {
  CloseCurrentBottomSheet();
  currentBottomSheetContainer = container;
}

export function DeleteObjectWithConfirm(objectId, circle) {
  // ПС (typecode 13) сама является "Питающим центром" для других объектов —
  // при её удалении сервер каскадно удаляет всё, что на неё ссылается через
  // linkedtp, поэтому здесь же сразу убираем это с карты, без релоада.
  const isPS = circle.options.typecode == 13;

  const handeleDelete = (event) => {
    fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/deleteObject`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
       body: JSON.stringify({
        id: objectId,
        deletedByUserId: GetUserId(),
        deletedByUsername: GetUserName(),
        entityName: circle.options.name
      })
    }).then((response) => {
      if (!response.ok) {
        return response.json().then((errData) => {
          throw new Error(errData.error || `Ошибка сервера: ${response.status}`);
        });
      }

      const actualMarker = loadedMarkers.get(objectId);
      if (actualMarker) {
        map.removeLayer(actualMarker);
        loadedMarkers.delete(objectId);
      } else {
        map.removeLayer(circle);
      }

      deletePolylineByFromId(objectId);
      deletePolylineByToId(objectId);

      // Если удалили ПС — убираем с карты всё, что было на неё завязано
      // (сервер это уже удалил каскадно, здесь просто синхронизируем клиент).
      if (isPS) {
        const psName = circle.options.name;

        // 1) ТП/РП/Реклоузер (и вообще всё, что грузится через LoadObjects)
        // хранятся плоско в loadedMarkers, без привязки к linkedtpArray —
        // ищем и убираем их напрямую по полю linkedtp в опциях маркера.
        for (const [markerId, marker] of loadedMarkers) {
          if (marker.options.linkedtp === psName) {
            map.removeLayer(marker);
            loadedMarkers.delete(markerId);
          }
        }

        // 2) Опоры и линии, загруженные пакетно через ShowAllPoles /
        // ShowAllVisiblePoles, хранятся в linkedtpArray.
        const foundObject = linkedtpArray.find(o => o.name === psName);
        if (foundObject) {
          foundObject.children.forEach(child => {
            child.circle.remove();
            loadedMarkers.delete(child.id);
          });
          foundObject.lines.forEach(l => {
            l.line.remove();
            const idx = linesData.polylineArray.indexOf(l.line);
            if (idx !== -1) {
              linesData.polylineArray.splice(idx, 1);
            }
          });
          foundObject.children = [];
          foundObject.lines = [];

          const ppIndex = linkedtpArray.indexOf(foundObject);
          if (ppIndex !== -1) {
            linkedtpArray.splice(ppIndex, 1);
          }
        }

        // 3) Подчищаем и оставшиеся полилинии по linkedtp — на случай, если
        // они не были учтены ни в foundObject.lines, ни привязаны к id
        // самого удаляемого объекта.
        linesData.polylineArray = linesData.polylineArray.filter(line => {
          if (line.options.linkedtp === psName) {
            line.remove();
            return false;
          }
          return true;
        });
      }

      if (objectId == lastInsertedId) {
        lastInsertedId = null;
      }
      if (lastOpenedPopup) {
        map.closePopup(lastOpenedPopup);
      }
    }).catch(error => {
      console.error(`ERROR with deleting pole ${objectId}:`, error);
      alert(`Не удалось удалить объект: ${error.message}`);
    });
  };

  const container = document.createElement('div');
  document.body.appendChild(container);
  const handeleClose = (event) => {
    ReactDOM.unmountComponentAtNode(container);
    container.remove();
  };

  const question = isPS
    ? `Вы уверены, что хотите удалить ПС "${circle.options.name}"? Вместе с ней будут удалены ВСЕ объекты и линии, у которых она указана как питающий центр.`
    : undefined;

  ReactDOM.render(<ModalWrap>
    <DeleteModal handeleDelete={handeleDelete} set={handeleClose} question={question}/>
  </ModalWrap>, container);
}

export function FunctionsReactStateSetup(handleMarkerClick, handleBottomMarkerClick, handeleLogOut, handleSideBar) {
  MarkerClick = handleMarkerClick;
  BottomMarkerClick = handleBottomMarkerClick;
  LogOutClick = handeleLogOut;
  OpenSideBar = handleSideBar;
}

 export function MapSetup(depname, user, userIdParam, permissions) {

  depName = depname;
  userName = user;
  userId = userIdParam;
  userPermissions = permissions;

  if (!(process.env.REACT_APP_IS_MOBILE === 'true')) {
    isMobileVersion = false;
  }

  if (isMobileVersion) {
      var imageContainer = document.getElementById('checkboxMobileGroup');
      imageContainer.style.display = 'none';
     // var hideButton = document.getElementById('hidePanel');
     // hideButton.addEventListener('click', function () {
     addSafeListener('hidePanel', function () {
        imageContainer.classList.add('hide');
        
        setTimeout(function() {
          document.getElementById('settingsButton').style.display = 'flex';
          imageContainer.style.display = 'none';
        }, 0.5 * 1000);
        
      });
  }

  let moveTimer;
let zoomTimer;

  try {
    map = L.map("map", {
  preferCanvas: false,          // ← это главное
  renderer: L.svg(),            // или просто без preferCanvas — SVG по умолчанию
  ...ROTATION_MAP_OPTIONS       // поворот карты (leaflet-rotate)
}).setView([47.106799, 51.916874], 15);

// Компас: на мобильном прячем, пока север наверху (крутят двумя пальцами)
setupMapRotation(map, { hideWhenNorth: isMobileVersion });

// Линейка (измерение расстояний с привязкой к объектам)
setupMeasureTool(map, {
  isMobile: isMobileVersion,
  onEnable: function () {
    ClearMarkerHighlight();
    clearLineHighlight();
    if (drawPolyline) drawPolyline.disable(); // если в этот момент рисуется линия
  }
});

SetupZoomHandler();

    // отмена функции зум при двойном клике
    
    
    // Добавление слоя Open Street Map
    const streetsLayer = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoicmFwaGFlbDkyIiwiYSI6ImNtZTg4eGZ2bDBhOXkyanBnOGlyamZoZnIifQ.YKB9dAYh37GGbreFmSxpTw', {
    attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors ' +
                 '© <a href="https://www.mapbox.com/">Mapbox</a>',
    tileSize: 512,
    zoomOffset: -1,
    maxZoom: 20,
    id: 'mapbox/streets-v12', // можно поменять стиль
    accessToken: 'ТВОЙ_MAPBOX_ACCESS_TOKEN' // сюда вставь свой токен
});

  const hybridLayer = L.tileLayer(
  'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoicmFwaGFlbDkyIiwiYSI6ImNtZTg4eGZ2bDBhOXkyanBnOGlyamZoZnIifQ.YKB9dAYh37GGbreFmSxpTw',
  {
    attribution:
      '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors ' +
      '© <a href="https://www.mapbox.com/">Mapbox</a>',
    tileSize: 512,
    zoomOffset: -1,
    maxZoom: 20,
    id: 'mapbox/satellite-streets-v12', // именно гибрид
    accessToken: 'pk.eyJ1IjoicmFwaGFlbDkyIiwiYSI6ImNtZTg4eGZ2bDBhOXkyanBnOGlyamZoZnIifQ.YKB9dAYh37GGbreFmSxpTw'
  }
);

const doubleGisLayer  = L.tileLayer('https://tile2.maps.2gis.com/tiles?x={x}&y={y}&z={z}', {
  maxZoom: 20,
  subdomains: ['mt0','mt1','mt2','mt3'],
  attribution: '© Google'
});

streetsLayer.addTo(map);

// Объект с базовыми слоями
const baseLayers = {
  'Mapbox': streetsLayer,
  'Гибрид': hybridLayer,
  '2GIS': doubleGisLayer
};

// Добавляем контрол переключения слоёв
L.control.layers(baseLayers, null, { 
  collapsed: true, // false — развёрнутый вид, true — свёрнутый (по умолчанию свёрнутый)
  position: 'topright'
}).addTo(map);

// На спутниковой подложке тёмные подписи теряются — помечаем контейнер карты
// классом, а стили подписей для него заданы в CSS (.map-satellite ...)
map.on('baselayerchange', function (e) {
  map.getContainer().classList.toggle('map-satellite', e.layer === hybridLayer);
});

    map.attributionControl.setPrefix('Leaflet');

   /* if (user === 'azhalpakov') {
      document.getElementById('showAllStat').style.visibility = 'hidden';
    }
    else {
      if (!isMobileVersion) {
        map.doubleClickZoom.disable();
        DoubleClickOnMapSetup();
      }
    }*/

  const drawnItems = new L.FeatureGroup();
map.addLayer(drawnItems);

const container = document.createElement('div');
document.body.appendChild(container);


      
ReactDOM.render(<VoltageLayersControl
        onVoltageClassesChange={handleVoltageClassesChange}
      />, container);

/*const drawControl = new L.Control.Draw({
  draw: {
    polygon: false,
    rectangle: false,
    circle: false,
    marker: false,
    circlemarker: false,
    polyline: true
  }
});
map.addControl(drawControl);*/

if (L.Draw && L.Draw.Polyline) {
  L.Draw.Polyline.prototype._onTouch = L.Util.falseFn;
}

drawPolyline = new L.Draw.Polyline(map, {
    shapeOptions: {
      color: 'black',
      weight: 3
    }
  });

  L.drawLocal = {
  draw: {
    toolbar: {
      actions: {
        title: 'Отменить рисование',
        text: 'Отмена'
      },
      finish: {
        title: 'Завершить',
        text: 'Готово'
      },
      undo: {
        title: 'Удалить последнюю точку',
        text: 'Назад'
      },
      buttons: {
        polyline: 'Нарисовать линию'
      }
    },
    handlers: {
      polyline: {
        tooltip: {
          start: 'Кликните, чтобы начать линию',
          cont: 'Кликните, чтобы добавить точку',
          end: 'Для завершения кликните по последней добавленной точке'
        }
      }
    }
  }
};

map.on(L.Draw.Event.CREATED, function (e) {
  const layer = e.layer;
  const latlngs = layer.getLatLngs();

  // Преобразуем в формат для БД
  const coords = latlngs.map(p => [p.lng, p.lat]);

  if (pendingLineMeta && pendingLineMeta.end_lat != null && pendingLineMeta.end_lng != null) {
    coords[coords.length - 1] = [pendingLineMeta.end_lng, pendingLineMeta.end_lat];
  }

  AddCurveLine({
    coords: coords,
    /*from_id: 1036,
    to_id: 1048,
    typecode: 7,
    linkedtp: 'test',
    start_name: 'start_test',
    end_name: 'end_name'*/
    ...pendingLineMeta
  });

  //drawnItems.addLayer(layer);
  pendingLineMeta = null;
});

// Рисование линии закончено (после CREATED) или отменено — снимаем выделение
// с объекта, от которого линия тянулась
map.on(L.Draw.Event.DRAWSTOP, function () {
  if (curveLineSourceMarker) {
    ClearMarkerHighlight(curveLineSourceMarker);
    curveLineSourceMarker = null;
  }
});

    map.doubleClickZoom.disable();
    DoubleClickOnMapSetup();

    LoadObjects();

   // document.getElementById('showUserLocation').addEventListener('click', function () {
    addSafeListener('showUserLocation', function () {
      showUserLocation();
    });

    //document.getElementById('ShowAllObjects').addEventListener('change', async function () {
    addSafeChangeListener('ShowAllObjects', async function () {
      if (this.checked) {
        var currentZoom = map.getZoom();
        if (currentZoom > 16) {
          await FillingShowingLinkedObjects();
          
          await ShowAllVisiblePoles(depName, selectedVoltageCodes);
        } else {
         // await FillingShowingLinkedObjects();
          map.setZoom(17);
        }
      } else {
        UnLoadAllPoles();
        UnLoadAllLines();
        ClearShowingLinkedObjects();
        ClearShowingAllLinkedObjects();
      }
      showAllObjectsByZoom = this.checked;
      
    });

    //document.getElementById('logOut').addEventListener('click', function () {
    addSafeListener('logOut', function () {
      LogOutClick();
    });

    //document.getElementById('showAllStat').addEventListener('click', function () {
      addSafeListener('showAllStat', function () {
        ShowAllStat();
      });

      addSafeListener('showSupport', function () {
        ShowSupport();
      });

    if (isMobileVersion) {
      document.getElementById('settingsButton').addEventListener('click', function () {
        
        showSettingsPanel();
      });
    }

    function showSettingsPanel() {
      var imageContainer = document.getElementById('checkboxMobileGroup');
      imageContainer.classList.remove('hide');
      imageContainer.style.display = 'block';
      document.getElementById('settingsButton').style.display = 'none';
    }

    //mapIsSet = true;

    
    function reloadVisibleArea() {
      var currentZoom = map.getZoom();
      if (currentZoom >= 14) {
        LoadObjects();
      }
      ShowAllVisiblePoles(depName, selectedVoltageCodes);
    }

    map.on('moveend', function() {
      clearTimeout(moveTimer);
      moveTimer = setTimeout(reloadVisibleArea, 200);
    });

    // При повороте в углы экрана попадают новые участки карты,
    // а moveend при этом не срабатывает — догружаем объекты отдельно.
    map.on('rotate', function() {
      clearTimeout(moveTimer);
      moveTimer = setTimeout(reloadVisibleArea, 300);
    });

    
    map.on('zoomend', async function () {
      clearTimeout(zoomTimer);
      zoomTimer = setTimeout(async function() {
        var currentZoom = map.getZoom();
        console.log(currentZoom);
        if (currentZoom < 17) {
          document.getElementById('ShowAllObjects').checked = false;
          UnLoadAllPoles();
          UnLoadAllLines();
          ClearShowingAllLinkedObjects();

          const activeFider = GetActiveFiderLineId();
          if (activeFider) {
            ShowFiderOnMap(activeFider, false);
          }
        }
        else if (showAllObjectsByZoom) {
          document.getElementById('ShowAllObjects').checked = true;
          await FillingShowingLinkedObjects();
          await ShowAllVisiblePoles(depName, selectedVoltageCodes);
        }
        if (currentZoom < 14) {
          ClearMainMarkersArray();
          loadedMarkers.clear();
        }
        else {
          LoadObjects();
        }
      }, 200);
    });
    
  }
  catch(error) {
    console.log(error);
  }
  
}

function showAddObjectSheet(latlng) {
  var isEditable = false;
  var departmentAccessArray = GetUserPermissions();
  if (departmentAccessArray[0]) {
    const role_id = departmentAccessArray[0].split("=")[1];
    switch (role_id) {
      case '1':
      case '2':
        isEditable = true;
        break;
    }
  }

  if (!isEditable) return;

  // Начинается добавление нового объекта — снимаем выделение с ранее выбранного
  // объекта/линии (их шторка закрывается через SetCurrentBottomSheet без своего handleClose)
  ClearMarkerHighlight();
  clearLineHighlight();

  const container = document.createElement('div');
  document.body.appendChild(container);
  SetCurrentBottomSheet(container);

  const handleClose = () => {
    ReactDOM.unmountComponentAtNode(container);
    container.remove();
  };

  const currentTime = new Date().getTime();

  const handleSelect = (typeKey) => {
    // Создаём фейковые кнопки в DOM чтобы существующие Setup функции работали
    const fakeBtn = document.createElement('button');
    fakeBtn.id = `${typeKey}-btn${currentTime}`;
    fakeBtn.style.display = 'none';
    document.body.appendChild(fakeBtn);

    switch (typeKey) {
      case 'PS': AddPPSetup(latlng, currentTime); break;
      case 'RP': AddObjectSetup(latlng, currentTime, OBJECT_TYPES.RP); break;
      case 'TP': AddObjectSetup(latlng, currentTime, OBJECT_TYPES.TP); break;
      case 'Recloser': AddObjectSetup(latlng, currentTime, OBJECT_TYPES.RECLOSER); break;
      case 'circle': AddPoleSetup(latlng, currentTime); break;
    }

    // Симулируем клик на фейковую кнопку
    fakeBtn.click();
    fakeBtn.remove();
  };

  ReactDOM.render(
    <AddObjectSheet
      onClose={handleClose}
      onSelect={handleSelect}
    />,
    container
  );
}

// Выделение объекта (опоры, ТП, ПС и т.д.).
// Выделение держится по id объекта: ShowAllVisiblePoles при каждом сдвиге карты
// пересоздаёт маркеры опор, а SetupZoomHandler при зуме меняет им иконки (setIcon) —
// в обоих случаях класс подсветки переносится на новый маркер / новую иконку.
var highlightedMarkerId = null;
var highlightedMarkerClass = null;

function sameObjectId(a, b) {
  return a !== undefined && a !== null && b !== undefined && b !== null && String(a) === String(b);
}

function applyMarkerHighlightClass() {
  if (!currentHighlightedMarker || !highlightedMarkerClass) return;
  const icon = currentHighlightedMarker.getElement();
  if (icon) icon.classList.add(highlightedMarkerClass);
}

function onMarkerLayerAddForHighlight(e) {
  const layer = e.layer;
  if (highlightedMarkerId === null || !(layer instanceof L.Marker)) return;
  if (layer.options && sameObjectId(layer.options.id, highlightedMarkerId)) {
    currentHighlightedMarker = layer;
    applyMarkerHighlightClass();
  }
}

export function HighlightMarker(marker, pulse = false) {
  ClearMarkerHighlight();
  clearLineHighlight(); // выделен может быть либо объект, либо линия
  if (!marker) return;

  currentHighlightedMarker = marker;
  highlightedMarkerClass = pulse ? 'marker-highlight-pulse' : 'marker-highlight-static';
  highlightedMarkerId = (marker.options && marker.options.id !== undefined) ? marker.options.id : null;

  applyMarkerHighlightClass();
  map.on('layeradd', onMarkerLayerAddForHighlight);
  map.on('zoomend', applyMarkerHighlightClass); // после SetupZoomHandler (он подписан раньше)
}

export function ClearMarkerHighlight(specificMarker = null) {
  // Если указан конкретный маркер — снимаем подсветку только если выделен всё ещё он же
  // (сравниваем и по id: в замыкании попапа может остаться старая копия маркера)
  if (specificMarker && currentHighlightedMarker !== specificMarker &&
      !(specificMarker.options && sameObjectId(specificMarker.options.id, highlightedMarkerId))) {
    return; // подсветка уже перешла на другой объект — ничего не делаем
  }

  if (currentHighlightedMarker) {
    const icon = currentHighlightedMarker.getElement();
    if (icon) {
      icon.classList.remove('marker-highlight-pulse', 'marker-highlight-static');
    }
  }
  currentHighlightedMarker = null;
  highlightedMarkerId = null;
  highlightedMarkerClass = null;
  if (map) {
    map.off('layeradd', onMarkerLayerAddForHighlight);
    map.off('zoomend', applyMarkerHighlightClass);
  }
}

// Выделение линии (подсветка под линией). Выделение объекта при этом снимается.
export function HighlightLine(polyline) {
  ClearMarkerHighlight();
  highlightLine(map, polyline);
}

export function ClearLineHighlight(specificPolyline = null) {
  clearLineHighlight(specificPolyline);
}



function ShowAllStat() {
  const container = document.createElement('div');
      document.body.appendChild(container);
      const handleClose = (event) => {
        ReactDOM.unmountComponentAtNode(container);
        container.remove();
      };
      ReactDOM.render(<ModalWrap>
        <Statistic setStatistic={handleClose}></Statistic>
      </ModalWrap>, container);
}

function ShowSupport() {
  if (isMobileVersion) {
    const container = document.createElement('div');
    document.body.appendChild(container);
    SetCurrentBottomSheet(container);

    const handleClose = () => {
      ReactDOM.unmountComponentAtNode(container);
      container.remove();
    };

    ReactDOM.render(<SupportSheet onClose={handleClose} />, container);
    return;
  }

  const container = document.createElement('div');
  document.body.appendChild(container);
  const handleClose = (event) => {
    ReactDOM.unmountComponentAtNode(container);
    container.remove();
  };
  ReactDOM.render(<ModalWrap>
    <SupportModal set={handleClose} />
  </ModalWrap>, container);
}

function SetUserLocation(lat, lng) {
  var latlng = L.latLng(lat, lng);

      var icon = L.icon({
        iconUrl: currentLocationImage
      });

      // Создаем и добавляем маркер текущего расположения на карту
      if (userMarker != null) {
        map.removeLayer(userMarker);
      }
      userMarker = L.marker(latlng).addTo(map);
      userMarker.setIcon(icon);
      userMarker.on('click', function () {
        // Удаляем маркер с карты
        map.removeLayer(userMarker);
      });
      map.setView(latlng, 18); // Устанавливаем масштаб и перемещаем карту к новому местоположению
}

async function showUserLocation() {
  if (!isMobileVersion) {
    // Web-версия
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => SetUserLocation(pos.coords.latitude, pos.coords.longitude),
        (err) => console.error('Web geolocation error:', err),
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
      );
    } else {
      console.error('Geolocation not supported');
    }
    return;
  }


  
  // Capacitor (iOS/Android)
  try {
    const status = await Geolocation.checkPermissions();
    if (status.location !== 'granted') {
      const req = await Geolocation.requestPermissions();
      if (req.location !== 'granted') {
        alert('Разрешите геолокацию в настройках');
        return;
      }
    }

    /*const watchId = await Geolocation.watchPosition(
  { enableHighAccuracy: true },
  (pos) => {
    if (pos) {
      SetUserLocation(pos.coords.latitude, pos.coords.longitude);
      Geolocation.clearWatch({ id: watchId });
    }
  }
);*/


   /* const timeoutPromise = new Promise((_, reject) =>
      setTimeout(() => reject(new Error('Timeout')), 12000)
    );

    const position = await Promise.race([
      Geolocation.getCurrentPosition({
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }),
      timeoutPromise
    ]);

    SetUserLocation(position.coords.latitude, position.coords.longitude);*/
    
     // 2️⃣ Быстро получить позицию (Wi-Fi / cell, почти всегда срабатывает)
    const fast = await Geolocation.getCurrentPosition({
      enableHighAccuracy: false,
      timeout: 5000,
      maximumAge: 60000
    });
    SetUserLocation(fast.coords.latitude, fast.coords.longitude);

    // 3️⃣ Точная позиция GPS (по возможности, timeout 15–20 сек)
    try {
      const precise = await Geolocation.getCurrentPosition({
        enableHighAccuracy: true,
        timeout: 20000,
        maximumAge: 0
      });
      SetUserLocation(precise.coords.latitude, precise.coords.longitude);
    } catch {
      console.warn('Точная геолокация не получена, используем приблизительную');
    }

  } catch (error) {
    console.error('Ошибка геолокации:', error);

    // Типичные коды ошибок из документации Capacitor
    if (error?.code === 'OS-PLUG-GLOC-0003' || error?.message?.includes('denied')) {
      alert('Геолокация запрещена. Включите в настройках iPhone.');
    } else if (error?.code === 'OS-PLUG-GLOC-0007') {
      alert('Службы геолокации выключены на устройстве. Включите их в настройках iPhone → Конфиденциальность → Службы геолокации.');
    } else if (error?.message?.includes('timeout') || error?.code === 3) {
      alert('Не удалось получить позицию (таймаут). Попробуйте на улице с хорошим GPS.');
    } else {
      alert('Ошибка получения местоположения: ' + (error?.message || 'неизвестно'));
    }
  }
}

export function ObjectFound(key, name, lat, lng) {
  const latlng = L.latLng(lat, lng);
  map.setView(latlng, 18); // Устанавливаем масштаб и перемещаем карту к новому местоположению
 
  // Если маркер уже загружен (например объект в зоне видимости не поменялся) — сработает сразу
  const existingMarker = loadedMarkers.get(key);
  if (existingMarker) {
    highlightAndOpenMarker(existingMarker);
    return;
  }

  // Иначе ждём событие о том что LoadObjects отработал после перемещения карты
  const handler = () => {
    const marker = loadedMarkers.get(key);
    if (marker) {
      highlightAndOpenMarker(marker);
    } else {
      console.warn('Маркер не найден в loadedMarkers для id:', key);
    }
    window.removeEventListener('objectsLoaded', handler);
  };

  window.addEventListener('objectsLoaded', handler);

  // Страховка — если событие почему-то не придёт (например зум не изменился 
  // достаточно для срабатывания moveend), снимаем подписку через 5 секунд
  setTimeout(() => {
    window.removeEventListener('objectsLoaded', handler);
  }, 5000);
}

  /*function highlightAndOpenMarker(marker) {
    const icon = marker.getElement();
    if (icon) {
      icon.classList.add('marker-highlight-pulse');
      setTimeout(() => {
        icon.classList.remove('marker-highlight-pulse');
      }, 2500);
    }
    marker.fire('click')
}*/

function highlightAndOpenMarker(marker) {
  HighlightMarker(marker, true); // ← pulse = true
  setTimeout(() => {
    marker.fire('click');
  }, 500);
  //marker.fire('click');
}

/*function highlightMarker(marker) {
  const icon = marker.getElement(); // DOM-элемент маркера
  if (!icon) return;

  icon.classList.add('marker-highlight-pulse');

  setTimeout(() => {
    icon.classList.remove('marker-highlight-pulse');
  }, 2500); // длительность подсветки
}*/

function addSafeListener(id, handler) {
  const el = document.getElementById(id);
  if (!el) return;
  const clone = el.cloneNode(true);
  el.replaceWith(clone);
  clone.addEventListener('click', handler);
}

function addSafeChangeListener(id, handler) {
  const el = document.getElementById(id);
  if (!el) return;
  const clone = el.cloneNode(true);
  el.replaceWith(clone);
  clone.addEventListener('change', handler);
}

export const loadedMarkers = new Map(); 

async function LoadObjects() {
  console.log('LoadObjects called, loadedMarkers size:', loadedMarkers.size);
  const newIds = new Set();

  var bounds = map.getBounds();
  var northEast = bounds.getNorthEast();
  var southWest = bounds.getSouthWest();
  const encodedDepName = encodeURIComponent(depName);
   try {
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/loadVisibleTPandPP?depName=${encodedDepName}&neLat=${northEast.lat}&neLng=${northEast.lng}&swLat=${southWest.lat}&swLng=${southWest.lng}`);
    const data = await response.json();
    data.forEach(object => {

      newIds.add(object.id);
      if (loadedMarkers.has(object.id)) return;
        if (object.typecode == 11) {
        const latlng = L.latLng(object.lat, object.lng);

        var circle_5 = DrawMainMarker(latlng, object.name, object.typecode, object.textPosition, null, object.id, object.linkedtp); //.addTo(map);
        if (circle_5) { circle_5.addTo(map); loadedMarkers.set(object.id, circle_5);}
        ObjectPopupSetup(circle_5, object.name, object.linkedtp, object.lat, object.lng, object.id, OBJECT_TYPES.TP);
        PopupBehavior(circle_5, object.id, latlng, object.linkedtp, object.typecode, object.name);
      } else if (object.typecode == 24) {
        const latlng_1 = L.latLng(object.lat, object.lng);

        var circle_5 = DrawMainMarker(latlng_1, object.name, object.typecode, object.textPosition, null, object.id, object.linkedtp); //.addTo(map);
        if (circle_5) { circle_5.addTo(map); loadedMarkers.set(object.id, circle_5);}
        ObjectPopupSetup(circle_5, object.name, object.linkedtp, object.lat, object.lng, object.id, OBJECT_TYPES.RP);
        PopupBehavior(circle_5, object.id, latlng_1, object.linkedtp, object.typecode, object.name);
      } else if (object.typecode == 25) {
        const latlng_1 = L.latLng(object.lat, object.lng);

        var circle_5 = DrawMainMarker(latlng_1, object.name, object.typecode, object.textPosition, null, object.id, object.linkedtp); //.addTo(map);
        if (circle_5) { circle_5.addTo(map); loadedMarkers.set(object.id, circle_5);}
        ObjectPopupSetup(circle_5, object.name, object.linkedtp, object.lat, object.lng, object.id, OBJECT_TYPES.RECLOSER);
        PopupBehavior(circle_5, object.id, latlng_1, object.linkedtp, object.typecode, object.name);
      }
      else if (object.typecode == 13) {

        const latlng_2 = L.latLng(object.lat, object.lng);
        var circle_5 = DrawMainMarker(latlng_2, object.name, object.typecode, object.textPosition, null, object.id, object.linkedtp, object.has_children); //.addTo(map);
        if (circle_5) { circle_5.addTo(map); loadedMarkers.set(object.id, circle_5);}
        PPPopupSetup(circle_5, object.name, object.lat, object.lng, object.id);
        PopupBehavior(circle_5, object.id, latlng_2, object.linkedtp, object.typecode, object.name);
        var ppObject = {
          id: object.id,
          name: object.name,
          children: [],
          lines: []
        };
        linkedtpArray.push(ppObject);
      } else {
        const latlng_3 = L.latLng(object.lat, object.lng);
        const circle_7 = DrawPoleMarker([object.lat, object.lng], object.typecode.toString(), null, object.name, 1, 2, object.textPosition, null, object.id, object.linkedtp).addTo(map);
        loadedMarkers.set(object.id, circle_7);
        PolePopupSetup(circle_7, object.name, object.linkedtp, object.lat, object.lng, object.id);
        PopupBehavior(circle_7, object.id, latlng_3, object.linkedtp, object.typecode, object.name);
      }
    });
    
    for (const [id, marker] of loadedMarkers) {
      if (!newIds.has(id)) {
        map.removeLayer(marker);
        loadedMarkers.delete(id);
      }
    }
      console.log('LoadObjects finished, data length:', data.length, 'loadedMarkers size after:', loadedMarkers.size);
      window.dispatchEvent(new CustomEvent('objectsLoaded'));
  } catch (error) {
    return console.error(error);
  }
  
}

export function ResetMapState() {
  loadedMarkers.clear();
  linkedtpArray.length = 0;
  ClearPPModuleState();
}

function AddLineSetup(object, circle) {
//  document.getElementById(`addLine${object.id}`).addEventListener('click', function () {
  addSafeListener(`addLine${object.id}`, function () {
    this.disabled = true;
    const from_id = object.id;
    /*const start_lat = object.lat;
    const start_lng = object.lng;*/
    var latLng = circle.getLatLng();
    const start_lat = latLng.lat;
    const start_lng = latLng.lng;
    const linkedtp = object.linkedtp;
    //let popupContent = 'Выберите объект соединения:<div style="-webkit-overflow-scrolling: touch; -webkit-appearance: none; overflow-y: scroll; height: 300px">';
    let end_lat, end_lng, to_id = null, end_name;

    const searchLink = `${process.env.REACT_APP_BASE_URL}/api/objects_list/getAllPolesByName?linkedtp=${object.linkedtp}&name=`;
    function handeleClickFind(id, name, lat, lng) {
      
      to_id = id;
      end_lat = lat;
      end_lng = lng;
      end_name = name;
      //linkedtp = name;
    }
    
    var popupContent = '<div id="divMainObjectNumber"></div>';
    var myDiv = document.createElement('div');

    myDiv.style.width = "350px";
    popupContent += `<br><div><button id="addSolidLine" class="simple_button">Добавить воздушную</button><button id="addDashedLine" class="simple_button">Добавить кабельную</button><button id="addCurveDashedLine" class="simple_button">Добавить кривую кабельную</button></div>
      <br><span class="error-text" id="errorText"></span>`;
      myDiv.innerHTML = popupContent;
      var addLinePopup = L.popup()
    .setContent(myDiv)
    .setLatLng(latLng)
    .openOn(map);

    // openOn закрыл попап объекта (и снял выделение) — выделяем снова, пока выбирается
    // объект соединения. Снимается при закрытии формы, кроме случая, когда начали
    // рисовать кривую линию (тогда — по окончании рисования, см. DRAWSTOP)
    HighlightMarker(circle);
    addLinePopup.on('remove', () => {
      if (curveLineSourceMarker !== circle) ClearMarkerHighlight(circle);
    });
   
    //document.getElementById(`editObject${objectId}`).addEventListener('click', function () {
    document.getElementById('addSolidLine').addEventListener('click', function () {
      this.disabled = true;
      handleLineButtonClick('8', this);
    });
    document.getElementById('addDashedLine').addEventListener('click', function () {
      this.disabled = true;
      handleLineButtonClick('7', this);
    });
    document.getElementById('addCurveDashedLine').addEventListener('click', function () {
      this.disabled = true;
      handleCurveLineButtonClick('7', this);
    });
    function handleLineButtonClick(typecode, button) {
      if (!to_id) {
        document.getElementById("errorText").textContent = "Не выбран объект соединения";
        button.disabled = false;
        return;
      }
      if (to_id == from_id) {
        document.getElementById("errorText").textContent = "Нельзя соединить объект с самим собой";
        button.disabled = false;
        return;
      }
      AddLine(from_id, to_id, typecode, start_lat, start_lng, end_lat, end_lng, linkedtp, object.name, end_name);

      map.closePopup(addLinePopup);
    }

    function handleCurveLineButtonClick(typecode, button) {
      if (!to_id) {
        document.getElementById("errorText").textContent = "Не выбран объект соединения";
        button.disabled = false;
        return;
      }
      if (to_id == from_id) {
        document.getElementById("errorText").textContent = "Нельзя соединить объект с самим собой";
        button.disabled = false;
        return;
      }

      var meta = {
        from_id: from_id,
        to_id: to_id,
        typecode: typecode,
        linkedtp: linkedtp,
        start_name: object.name,
        end_name: end_name,
        end_lat: end_lat,       // ← добавить
        end_lng: end_lng
      };

  StartCurveLine(latLng, meta, circle);

      map.closePopup(addLinePopup);
    }

    const container = document.getElementById('divMainObjectNumber');
    ReactDOM.render(<div className="div__flex" ><label for="mainObjectNumber">Выберите объект: </label><div id="mainObjectNumber"><SearchComponent
      handeleClickFind={handeleClickFind}
      link={searchLink}
      home={false}
      propsValue=""
    ></SearchComponent></div></div>, container);

  });
}
function DoubleClickOnMapSetup() {
  // Добавление объекта на карту при двойном клике

  if (isMobileVersion) {
    // Long press на мобильном
    let pressTimer = null;
    let pressLatLng = null;

    map.on('mousedown touchstart', function(e) {
      // В режиме линейки тап ставит точку измерения, а не добавляет объект
      if (isMeasureModeActive()) {
        clearTimeout(pressTimer);
        return;
      }

      // Игнорируем мультитач — два и более пальцев (жест зума)
      if (e.originalEvent && e.originalEvent.touches && e.originalEvent.touches.length > 1) {
        console.log('click clear')
        clearTimeout(pressTimer);
        return;
      }

      // Игнорируем клик по маркеру, попапу или любому интерактивному элементу
    const target = e.originalEvent.target;
    if (target && (
      target.closest('.leaflet-marker-icon') ||
      target.closest('.leaflet-interactive') ||  // маркеры и полилинии
      target.closest('.leaflet-popup') ||
      target.closest('.leaflet-tooltip') ||
      target.closest('.leaflet-control')
    )) {
      return; // не запускаем long press — это клик по объекту
    }

      pressLatLng = e.latlng;
      pressTimer = setTimeout(function() {
        showAddObjectSheet(pressLatLng);
      }, 600);
    });

    map.on('mouseup touchend', function() {
      console.log('touchend')
      clearTimeout(pressTimer);
    });

    map.on('mousemove touchmove', function() {
      console.log('touchend touchmove')
      clearTimeout(pressTimer);
    });

    // Страховка: pinch-zoom отменяет таймер
    map.on('zoomstart movestart rotate', function() {
      clearTimeout(pressTimer);
    });

    // Нативный обработчик: ловит появление ВТОРОГО пальца,
    // когда таймер уже запущен первым пальцем
    const mapContainer = map.getContainer();
    mapContainer.addEventListener('touchstart', function(e) {
      if (e.touches.length > 1) {
        clearTimeout(pressTimer);
      }
    }, { passive: true });

    mapContainer.addEventListener('touchmove', function() {
      clearTimeout(pressTimer);
    }, { passive: true });

    return;
  }

  var lastClickTime = 0;
  var delay = 300; // Временная задержка между кликами в миллисекундах (например, 300 мс)

  var isEditable = false;
  var departmentAccessArray = GetUserPermissions();
  if (departmentAccessArray[0]) {
    const role_id = departmentAccessArray[0].split("=")[1];
      switch (role_id) {
        case '1':
        case '2':
          isEditable = true;
          break;
        case '3':
          isEditable = false;
          break;
      }
  }

  map.on('click', function (event) {
    // В режиме линейки клики ставят точки измерения — двойной клик не добавляет объект
    if (isMeasureModeActive()) {
      lastClickTime = 0;
      return;
    }
    var currentTime = new Date().getTime();
    if (currentTime - lastClickTime < delay && isEditable) {
      // Это двойной клик
      var latlng = map.mouseEventToLatLng(event.originalEvent); // Получение координат клика

      var objectShapeButtons = `<b>Выберете объект для добавления</b><br>
            <button id="PS-btn${currentTime}" class="simple_button">ПС</button>
            <button id="RP-btn${currentTime}" class="simple_button">РП</button>
            <button id="TP-btn${currentTime}" class="simple_button">ТП</button>
            <button id="Recloser-btn${currentTime}" class="simple_button">Реклоузер</button>
            <button id="circle-btn${currentTime}" class="simple_button">Опора</button>`;
      var popup = L.popup().setContent(objectShapeButtons).setLatLng(latlng).openOn(map);
      doubleClickHandler(latlng, popup, currentTime);
    }
    lastClickTime = currentTime;
  });



  function doubleClickHandler(latlng, popup, currentTime) {
    // Обработка двойного клика
    AddPoleSetup(latlng, currentTime);
    AddObjectSetup(latlng, currentTime, OBJECT_TYPES.TP);
    AddPPSetup(latlng, currentTime);
    AddObjectSetup(latlng, currentTime, OBJECT_TYPES.RP);
    AddObjectSetup(latlng, currentTime, OBJECT_TYPES.RECLOSER);
    //AddDecorativeSetup(latlng, popup, currentTime, 10);
    //AddDecorativeSetup(latlng, popup, currentTime, 12);
  }
}

export function PopupBehavior(circle, objectId, latlng, linkedtp, typecode, objectName) {
  
  // создание popup для круга с возможностью удалить его
  circle.on('click', function () {

    //document.getElementById(`deleteObject${objectId}`).addEventListener('click', function () {
    // Раньше здесь был отдельный, дублирующий DeleteObjectWithConfirm обработчик
    // удаления (для десктопных попапов) — без предупреждения о каскадном
    // удалении при удалении ПС и без очистки карты от её "детей". Теперь
    // десктоп и мобилка используют одну и ту же функцию.
    addSafeListener(`deleteObject${objectId}`, function () {
      DeleteObjectWithConfirm(objectId, circle);
    });
    switch (typecode) {
      case 2:
      case 3:
      case 4:
      case 5:
      case 14:
      case 15:
      case 16:
      case 17:
      case 18:
      case 19:
      case 20:
      case 21:
      case 22:
        MarkerClick(1, objectId, objectName, false, false);
        addSafeListener(`editObject${objectId}`, function () {
          this.disabled = true;
          EditPoleSetup(objectId, latlng, circle);
        });
     /*   document.getElementById(`editObject${objectId}`).addEventListener('click', function () {
          this.disabled = true;
          EditPoleSetup(objectId, latlng, circle);
        });*/
        PopupLineSetup(objectId, latlng, circle, linkedtp, objectName);
        addSafeListener(`passport${objectId}`, function () {
          OpenSideBar(true);
        });
      /*  document.getElementById(`passport${objectId}`).addEventListener('click', function() {
          //ShowPassport(objectId, latlng, circle);
          //MarkerClick(typecode, objectId);
          OpenSideBar(true);
        });*/
        break;
      case 10:
        /*document.getElementById(`editObject${objectId}`).addEventListener('click', function () {
          this.disabled = true;
          EditDecorativeSetup(objectId, latlng, circle);
        });*/
        addSafeListener(`editObject${objectId}`, function () {
          this.disabled = true;
          EditDecorativeSetup(objectId, latlng, circle);
        });
        break;
      case 11:
        MarkerClick(typecode, objectId, objectName, false, false);
        addSafeListener(`editObject${objectId}`, function () {
          this.disabled = true;
          EditObjectSetup(objectId, latlng, circle, OBJECT_TYPES.TP);
        });

        addSafeListener(`passport${objectId}`, function () {
          OpenSideBar(true);
        });

        PopupLineSetup(objectId, latlng, circle, linkedtp, objectName);
        break;
      case 12:
        addSafeListener(`editObject${objectId}`, function () {
          this.disabled = true;
          EditDecorativeSetup(objectId, latlng, circle);
        });
        break;
      case 13:
        MarkerClick(typecode, objectId, objectName, false, false);
        BottomMarkerClick(linkedtp);
        addSafeListener(`editObject${objectId}`, function () {
          this.disabled = true;
          EditPPSetup(objectId, latlng, circle);
        });
        addSafeListener(`showFiders${objectId}`, function () {
          ShowFidersList(linkedtp, objectId);
        });
        addSafeListener(`showAll${objectId}`, function () {
          ShowAllPoles(linkedtp, selectedVoltageCodes);
        });

        addSafeListener(`hideAll${objectId}`, function () {
          HideAllPoles(linkedtp);
        });

        addSafeChangeListener(`IsMovingObj${objectId}`, function () {
          SetMovingPPid(linkedtp, this.checked);
          SetDraggable(this.checked, linkedtp);
        });

        addSafeListener(`passport${objectId}`, function () {
          OpenSideBar(true);
        });

        PopupLineSetup(objectId, latlng, circle, linkedtp, objectName);
        break;
      case 24:
        MarkerClick(typecode, objectId, objectName, false, false);
        addSafeListener(`editObject${objectId}`, function () {
          this.disabled = true;
          EditObjectSetup(objectId, latlng, circle, OBJECT_TYPES.RP);
        });

        addSafeListener(`passport${objectId}`, function () {
          OpenSideBar(true);
        });

        PopupLineSetup(objectId, latlng, circle, linkedtp, objectName);
        break;
      case 25:
        MarkerClick(typecode, objectId, objectName, false, false);
        addSafeListener(`editObject${objectId}`, function () {
          this.disabled = true;
          EditObjectSetup(objectId, latlng, circle, OBJECT_TYPES.RECLOSER);
        });

        addSafeListener(`passport${objectId}`, function () {
          OpenSideBar(true);
        });

        PopupLineSetup(objectId, latlng, circle, linkedtp, objectName);
        break;
    }
  });
}
function PopupLineSetup(objectId, latlng, circle, linkedtp, objectName) {
  var objectJson = new Object();
  objectJson.id = objectId;
  /*objectJson.lat = latlng.lat;
  objectJson.lng = latlng.lng;*/
  objectJson.linkedtp = linkedtp;
  objectJson.name = objectName;
  AddLineSetup(objectJson, circle);
}